export default __webpack_public_path__ + "static/media/por_que.010aaf0a.svg";